import React, { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { CrmLeads } from './CrmLeads'
import { CrmBilling } from './CrmBilling'

/**
 * LEADS HUB (Lee, 26 Oct 2026 — companies ARE leads): the Leads page carries
 * a Billing view — the old all-companies billing list — as a tab, alongside
 * the lead list itself. Per-lead billing stays on each lead's Invoices tab.
 */
const TABS = [
  { key: 'leads', label: 'Leads' },
  { key: 'billing', label: 'Billing' },
]

export const CrmLeadsHub: React.FC = () => {
  const [sp, setSp] = useSearchParams()
  const [view, setView] = useState<string>(() => (sp.get('view') === 'billing' ? 'billing' : 'leads'))
  useEffect(() => {
    const cur = sp.get('view') || 'leads'
    if (cur !== view) {
      if (view === 'leads') sp.delete('view'); else sp.set('view', view)
      setSp(sp, { replace: true })
    }
  }, [view]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="h-full flex flex-col overflow-hidden">
      <div className="shrink-0 flex items-center gap-1 px-4 pt-3 pb-0 bg-surface border-b border-border">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setView(t.key)}
            className={`px-3.5 py-2 rounded-t-lg text-[12.5px] font-bold border-b-2 -mb-px transition-colors ${
              view === t.key ? 'text-brand-700 border-brand-600 bg-surface' : 'text-txt-tertiary border-transparent hover:text-txt-primary'}`}>
            {t.label}
          </button>
        ))}
      </div>
      <div key={view} className="flex-1 min-h-0 overflow-hidden animate-fade-in">
        {view === 'leads' ? <CrmLeads /> : <div className="h-full overflow-y-auto"><CrmBilling /></div>}
      </div>
    </div>
  )
}

export default CrmLeadsHub
